import React, { FC } from 'react';

import { NavIcons } from '../NavIcons'; 
import { ROUTES } from 'theSource/app/routes';
import { getCompanyName } from 'theSource/utils';

export interface NavLinkGroupProps {
  heading: string;
  children?: React.ReactNode;
}

export const NavLinkGroup: FC<NavLinkGroupProps> = ({ children, heading }) => {
  return (
    <div className="nav-link-group" data-testid="nav-link-group">
      {heading === 'home' ? (
        <a
          href={`/${getCompanyName()}${ROUTES.main.home.path}`}
          className="home-link-heading"
        >
          <h2 className="links-heading">
            <NavIcons navIcon="home" />
            {heading}
          </h2>
        </a>
      ) : (
        <h2 className="links-heading">
          <NavIcons navIcon={heading.toLowerCase()} />
          {heading}
        </h2>
      )}
      {children}
    </div>
  );
};
